import { combineSlices, configureStore } from "@reduxjs/toolkit";
import { candidateSlice } from "./features/candidate/candidate-slice";
import { noteSlice } from "./features/note/note-slice";
import { procedureSlice } from "./features/procedure/procedure-slice";
import { relationContactSlice } from "./features/relationContact/relationContact-slice";
import { relationContactRelationSlice } from "./features/relationContact/relationContactRelation-slice";

const rootReducer = combineSlices(candidateSlice, noteSlice, procedureSlice, relationContactSlice, relationContactRelationSlice);

export const store = configureStore({
    reducer: rootReducer
});